

































export default {
    name: 'RejectJobApplicantDialog',

    props: {
        application: {
            required: true,
            type: Object,
        },

        job: {
            required: true,
            type: Object,
        },
    },

    setup(props, { emit }) {
        const { $auth, $store } = useNuxtApp();

        const loading = ref<boolean>(false);
        const error = ref<string | null>(null);

        const defaultMessage = `Hi there,

Thank you for taking the time to apply for the ${props.job.title} role. We appreciate your interest in joining our team.

After careful consideration, we regret to inform you that we have decided not to move forward with your application at this time.

We encourage you to continue your job search and wish you success in finding a position that meets your career goals. Thank you again for considering ${props.job.company.name}, and we appreciate your interest in our organization.

Sincerely,
${$auth.user.name}`;

        const message = ref<string>(defaultMessage);

        const close = () => {
            emit('close-modal');
        };

        const reject = () => {
            loading.value = true;
            error.value = '';

            $store
                .dispatch('applications/rejectApplication', {
                    applicationUuid: props.application.uuid,
                    message: message.value,
                })
                .then(() => {
                    message.value = null;
                    close();
                })
                .catch(({ response }) => {
                    error.value = response?.status === 422 ? response.data.message : 'Oops! Something wrong. Please try again.';
                })
                .finally(() => {
                    loading.value = false;
                });
        };

        const clearError = () => {
            error.value = null;
        };

        return {
            clearError,
            close,
            error,
            loading,
            message,
            reject,
        };
    },
};
